import { createSelector } from '@reduxjs/toolkit';
import { selectLocation } from './selectLocation';
import { getRegionId } from 'shared/utils/geo';

export const selectRegionId = createSelector(selectLocation, location => getRegionId(location));
